/**
 * Comp_BE API Client
 * Handles API calls to Comp Backend for Job Builder / Job Architecture data.
 */

import axios, { type InternalAxiosRequestConfig } from 'axios';
import { getAuthToken } from './api';

const COMP_API_BASE_URL = (
  import.meta.env.VITE_PAY_BUILDER_API_URL || 'http://localhost:5009/api/comp-bldr'
).replace(/\/+$/, '');

const compApiClient = axios.create({
  baseURL: COMP_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

compApiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getAuthToken();
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default compApiClient;
